import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import IconMail from '@/assets/icons/heroIcons/Mail.svg';
export function RefundSentLogout() {
  const $ = _c(12);
  const {
    t
  } = useTranslation("overpayRefund");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <IconMail className="h-10 w-10 text-blue-500" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("sent.subtitle");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <h2 className="w-full text-center text-lg font-bold lg:text-4xl">{t1}</h2>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("sent.textNotSignedIn");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <p className="text-center">{t3}</p>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className="mb-[160px] flex flex-col items-center justify-center gap-6 rounded-4xl bg-white p-10 lg:p-12">{t0}{t2}{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}